<template>
	<div class="labelSelect" :style="{width:componentWidth}">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">
			<span style="color: red;" v-if="spanRequired">*&nbsp;</span>
			{{spanTitle}}:
		</span>
		<div class="innerP">
			<div v-for="(select,index) in selectList" :key="index"  :style="{width: selectWidth}">
				<el-select v-model="value" :placeholder="selectHolder[index].placeHolder" class="selectInner" change="selectChange">
					<el-option v-for="item in select" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectHolder:[
					{
						placeHolder:'省'
					},{
						placeHolder:'市'
					},{
						placeHolder:'县（区）'
					}
				],
				selectList: [
					[{
						value: '选项1',
						label: '江苏省'
					}, {
						value: '选项2',
						label: '浙江省'
					}, ],
					[{
						value: '选项1',
						label: '南京市'
					}, {
						value: '选项2',
						label: '常州市'
					}, ],
					[{
						value: '选项1',
						label: '鼓楼区'
					}, {
						value: '选项2',
						label: '雨花台区'
					}, ]
				],
				value: ''
			}
		},
		computed:{
			selectWidth(){
				let licaoWidth = parseInt(100/this.selectList.length-1)+'%'
				return licaoWidth
			}
		},
		props: {
			// 默认组件宽度
			componentWidth:{
				type:String,
				default:'600px'
			},
			// span类
			spanColor: {
				type: String,
				default: '#000'
			},
			spanFontSize: {
				type: Number,
				default: 16
			},
			spanTitle: {
				type: String,
				default: '标题'
			},
			spanWidth: {
				type: String,
				default: '100px'
			},
			// 限制必填
			spanRequired: {
				default: Boolean,
				default: false
			},
		},
		methods:{
			selectChange(e){
				this.$emit('selectChange',e)
			}
		}
	}
</script>

<style>
	.labelSelect {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		margin: 10px 10px;
	}

	.innerSpan {
		display: inline-block;
		/*display: inherit;*/
		justify-content: flex-end;
		text-align: left;
	}

	.innerP {
		display: inline-block;
		display: inherit;
		justify-content: space-between;
		/* justify-content: flex-start; */
		padding-left: 20px;
	}
	>>>.el-select{
		width: 100%;
	}
</style>
